export default __webpack_public_path__ + "static/media/done.0c06983c.png";